export default __webpack_public_path__ + "static/media/dogecoin-doge-logo.7008ccc7.svg";